import { render, staticRenderFns } from "./ProgramFooter.vue?vue&type=template&id=4de68c19&scoped=true&"
import script from "./ProgramFooter.vue?vue&type=script&lang=ts&"
export * from "./ProgramFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramFooter.vue?vue&type=style&index=0&id=4de68c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de68c19",
  null
  
)

export default component.exports